// Styles
import { flexChildSizeFlexible, flexParent, styleScrollbar } from "@ms/uno-controls/lib/local/utilities/Mixin.styles";
import { memoizeFunction, mergeStyles } from "@fluentui/react";
// Constants
import { UnoLeftNavBoxShadow, UnoLeftNavMaxWidth, UnoLeftNavWidth } from "@ms/uno-controls/lib/local/constants/StyleConstants";
/**
 * Helper to get styles for the Uno shell
 * @param theme The theme
 * @param modalSuspenseStyle The style to be applied to the modal suspense
 */ export const getUnoShellStyles = memoizeFunction((theme, modalSuspenseStyle)=>{
    const unoShellStyles = {
        root: [
            flexParent("column"),
            {
                backgroundColor: theme.semanticColors.bodyBackground,
                maxHeight: "100vh",
                maxWidth: "100vw",
                inset: "0px",
                position: "fixed",
                ":global(*)": styleScrollbar(theme),
                ul: {
                    margin: "0",
                    padding: "0"
                },
                li: {
                    listStyleType: "none"
                }
            }
        ],
        appContent: [
            flexParent("row"),
            flexChildSizeFlexible()
        ],
        mainContentContainer: {
            float: "none",
            overflow: "hidden",
            width: "100%",
            backgroundColor: theme.semanticColors.bodyBackground,
            position: "relative"
        },
        modalContainer: {
            height: "100vh",
            width: "100vw",
            zIndex: 1,
            position: "absolute",
            backgroundColor: theme.palette.neutralLight
        },
        emptyModal: [
            {
                position: "fixed",
                height: "300px",
                width: "450px",
                top: "50%",
                left: "50%",
                display: "flex",
                transform: "translate(-50%, -50%)",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                backgroundColor: theme.semanticColors.bodyBackground,
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 0px 5px 0px"
            },
            modalSuspenseStyle
        ],
        notificationBar: {
            width: "100%",
            [`& > .notificationBar.hidden`]: {
                display: "none"
            }
        },
        leftNavContainer: [
            flexParent("column"),
            {
                width: UnoLeftNavWidth,
                maxWidth: UnoLeftNavMaxWidth,
                backgroundColor: theme.semanticColors.bodyBackground,
                boxShadow: UnoLeftNavBoxShadow,
                borderRight: `1px solid ${theme.semanticColors.bodyDivider}`
            }
        ]
    };
    return unoShellStyles;
});
/**
 * Get the classnames associated with the computed styles for the Uno shell
 * @param styles The styles for the component
 */ export const getUnoShellClassNames = memoizeFunction((styles)=>{
    return {
        root: mergeStyles("root", styles.root),
        appContent: mergeStyles("appContent", styles.appContent),
        mainContentContainer: mergeStyles("mainContentContainer", styles.mainContentContainer),
        modalContainer: mergeStyles("modalContainer", styles.modalContainer),
        notificationBar: mergeStyles("notificationBar", styles.notificationBar),
        emptyModal: mergeStyles("emptyModal", styles.emptyModal),
        leftNavContainer: mergeStyles("leftNavContainer", styles.leftNavContainer)
    };
});
/**
 * Helper to get styles for Fabric
 */ export const getFabricStyles = memoizeFunction(()=>{
    return {
        root: {
            height: "100%",
            "> *:nth-child(1)": {
                height: "100%",
                "> *:nth-child(1)": {
                    height: "100%"
                }
            }
        },
        bodyThemed: {}
    };
});
